module.exports = __webpack_public_path__ + "static/media/auth-icon.45def1a7.svg";